import moment from 'moment';
import React from 'react';
import { CardContent, Typography, Table, TableBody, TableRow, TableCell, Divider, Box } from '@mui/material';

import { displayClientName } from '../../utils/Utils';
import ServiceChip from '../../utils/ServiceChip';

function BookingSummary ({booking}) {
    if (!booking) return null;

    const vehicleText = booking.vehicle
        ? `${booking.vehicle.registration || ''} ${booking.vehicle.model?.vehicle_make || ''} ${booking.vehicle.model?.vehicle_model || ''}`.trim()
        : '';
    const pickupLoc = booking.pickup_location?.location || booking.delivery_address || '';
    const dropoffLoc = booking.dropoff_location?.location || booking.collection_address || '';
    const summaryEntries = booking.booking_summary && typeof booking.booking_summary === 'object'
        ? Object.entries(booking.booking_summary)
        : [];

    return (
        <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, marginBottom: 1 }}>
                <Typography variant='h6'>
                    Booking {booking.reference || ''}
                </Typography>
                {booking.service_type && <ServiceChip serviceType={booking.service_type} />}
            </Box>
            <Typography variant='subtitle1' gutterBottom>
                {booking.client ? displayClientName(booking.client) : ''}
            </Typography>
            {vehicleText && (
                <Typography variant='subtitle1' gutterBottom>
                    {vehicleText}
                </Typography>
            )}
            <Typography variant='body1'>
                Pick-up: {booking.pickup_datetime ? moment(booking.pickup_datetime).format('D-MMM-YYYY') : ''} at {pickupLoc}
            </Typography>
            <Typography variant='body1' gutterBottom>
                Drop-off: {booking.dropoff_datetime ? moment(booking.dropoff_datetime).format('D-MMM-YYYY') : ''} at {dropoffLoc}
            </Typography>
            <Divider sx={{marginBottom: '20px'}} />
            <Typography variant='subtitle2' gutterBottom>
                Items
            </Typography>
            <Table sx={{marginBottom: '20px'}}>
                <TableBody>
                    {summaryEntries.map(([label, value]) => {
                        if (!Array.isArray(value)) return null;
                        return label === 'rental' ? (
                            <TableRow key={label}>
                                <TableCell>{value[0]} days rental</TableCell>
                                <TableCell>{value[1]}</TableCell>
                            </TableRow>
                        ) : (
                            <TableRow key={label}>
                                <TableCell>{value[0]}</TableCell>
                                <TableCell>{value[1]}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </CardContent>
    )
}

export default BookingSummary;